import { useTranslation } from 'react-i18next';
import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { setTag, setUser, withProfiler } from '@sentry/react';
import app from '@/utils/app';
import { portalCompany, portalUser } from '@/state/portalAuth';

const SentryProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { i18n } = useTranslation();
  const user = useAtomValue(portalUser);
  const company = useAtomValue(portalCompany);

  useEffect(() => {
    setTag('idk.lang', i18n.language);
  }, [i18n]);

  useEffect(() => {
    setTag('idk.env', app.env);
  }, []);

  useEffect(() => {
    let result = null;

    if (user && company) {
      result = {
        username: `PortalUser(id: ${user.id}, company: ${company.id})`,
      };
    } else if (user) {
      result = { username: `PortalUser(id: ${user.id})` };
    }

    setUser(result);
  }, [user, company]);

  return <>{children}</>;
};

export default withProfiler(SentryProvider);
